const en = {
    dayNamesShort: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    dayNames: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    monthNamesShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    amPm: [
        'am',
        'pm'
    ],
    DoFn: (day)=>`${day}°`
};
const humanized = {
    SECONDS_AGO: 'A moment ago',
    A_MINUTE_AGO: 'A minute ago',
    MINUTES_AGO: (mins)=>`${mins} minutes ago`,
    AN_HOUR_AGO: 'An hour ago',
    HOURS_AGO: (hours)=>`${hours} hours ago`,
    A_DAY_AGO: 'A day ago',
    DAYS_AGO: (days)=>`${days} days ago`,
    A_MONTH_AGO: 'A month ago',
    MONTHS_AGO: (months)=>`${months} months ago`,
    A_YEAR_AGO: 'A year ago',
    YEARS_AGO: (years)=>`${years} years ago`
};
const remaining = {
    SECONDS_AGO: 'a moment',
    A_MINUTE_AGO: 'a minute',
    MINUTES_AGO: (mins)=>`${mins} minutes`,
    AN_HOUR_AGO: 'an hour',
    HOURS_AGO: (hours)=>`${hours} hours`,
    A_DAY_AGO: 'a day',
    DAYS_AGO: (days)=>`${days} days`,
    A_MONTH_AGO: 'a month',
    MONTHS_AGO: (months)=>`${months} months`,
    A_YEAR_AGO: 'a year',
    YEARS_AGO: (years)=>`${years} years`
};
const locales_en = en;
export default locales_en;
export { humanized, remaining };
